<template>
  <main class="page-shell">
    <section class="section">
      <div class="container">
        <article class="surface blog-placeholder fade-up">
          <p class="eyebrow">Blog</p>
          <h1>Insights on Enterprise Delivery</h1>
          <p>
            Upcoming articles will cover architecture decisions, automation implementation notes,
            and practical delivery lessons from real-world projects.
          </p>
          <router-link to="/" class="back-link">Back to Portfolio</router-link>
        </article>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: "BlogPlaceholder",
  mounted() {
    document.title = "Blog | Jerald Pamugas";
  }
};
</script>

<style scoped>
.blog-placeholder {
  padding: clamp(1.6rem, 4vw, 3rem);
  max-width: 760px;
}

.eyebrow {
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--text-muted);
  font-size: 0.8rem;
}

h1 {
  margin: 0.5rem 0 0.8rem;
  font-family: var(--font-display);
  font-size: clamp(1.8rem, 4vw, 2.8rem);
}

p {
  margin: 0;
  color: var(--text-secondary);
  line-height: 1.75;
}

.back-link {
  margin-top: 1.2rem;
  display: inline-block;
  color: var(--text-primary);
  text-decoration: none;
  border-bottom: 1px solid rgba(255, 255, 255, 0.35);
}

.back-link:hover,
.back-link:focus-visible {
  color: var(--accent);
  border-color: var(--accent);
}
</style>
